import api from '@/services/index.js'
import store from '@/store/index.js'

import { ImageCasino, ImageSlot, ImagePOKER, ImageTRADING } from '@/config/Game'
import {
  ImageCasinoBetflik,
  ImageSlotBetflik,
  ImagePOKERBetflik,
  ImageTRADINGBetflik,
} from '@/config/GameBetflik'

async function getCredit(callback) {
  await api
    .get('/user-profile-composite/v1/profile/balance')
    .then((v) => {
      callback({ status: true, data: v.data, message: e.message })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

async function getUserRefresh(callback) {
  await api
    .get('/auth-service/v1/refresh')
    .then((v) => {
      callback({ status: true, data: v.data, message: e.message })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

async function getPrefix(callback) {
  api
    .get('/v2/prefix')
    .then((v) => {
      var Partner = v.data.Partner
      var ImageCasinos = Partner != 'Betflik' ? ImageCasino : ImageCasinoBetflik
      var ImagePOKERs = Partner != 'Betflik' ? ImagePOKER : ImagePOKERBetflik
      var ImageTRADINGs =
        Partner != 'Betflik' ? ImageTRADING : ImageTRADINGBetflik
      var ImageSlots = Partner != 'Betflik' ? ImageSlot : ImageSlotBetflik
      var gameAll = ImageCasinos.concat(ImageSlots)
        .concat(ImagePOKERs)
        .concat(ImageTRADINGs)
      store.commit('setGameList', {
        ImageCasino: ImageCasinos,
        ImagePOKER: ImagePOKERs,
        ImageTRADING: ImageTRADINGs,
        ImageSlot: ImageSlots,
        all: gameAll,
      })
      localStorage.setItem(
        'gameList',
        JSON.stringify({
          ImageCasino: ImageCasinos,
          ImagePOKER: ImagePOKERs,
          ImageTRADING: ImageTRADINGs,
          ImageSlot: ImageSlots,
          all: gameAll,
        })
      )

      store.commit('setPromotion', v.data.Promotion)
      store.commit('setPrefix', v.data)
      callback({ status: true, data: v.data, message: '' })
    })
    .catch((e) => {
      callback({ status: false, data: '', message: e.message })
    })
    .finally(() => {})
}

export { getCredit, getUserRefresh, getPrefix }



// WEBPACK FOOTER //
// ./src/services/modules/global.js